
import { crearSmartlink } from "../../smartlinks/utils/createLink.js";

export const createSmartLinkService = async (payload, provider) => {
  let endpoint = "";

  if (provider === "blumon") {
    endpoint = "/api/v1/payment-links/gen"; 
  } else if (provider === "kushki") {
    endpoint = "/api/v1/create_links"; 
  } else {
    throw new Error("Proveedor de pago no válido o no definido." + provider);
  }


  return await crearSmartlink(payload, endpoint);
};